module.exports = __webpack_public_path__ + "static/media/info.fdf153e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/info.svg
// module id = 780
// module chunks = 0